import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { ShadowLayout, TransitionConfig } from 'library/constants/styles-config';
import { IconBase } from '../../styles/icon';

export const Wrapper = styled.div`
  position: sticky;
  top: 71px;
  z-index: 19;
`;

const Container = styled.nav`
  position: relative;
  z-index: 18;
  padding: 5px 20px 5px 24px;
  font-size: 13px;
  font-weight: bold;
  color: ${Colors.shade02};
  background-color: ${Colors.shade07};
  box-shadow: ${ShadowLayout};
  
  em {
    font-style: normal;
  }
  
  p {
    font-weight: normal;
    color: ${Colors.shade03};
  }

  ${({ isLongerModal }) => isLongerModal && `
    display: flex;
    flex-direction: column;
    box-shadow: none;
  `}
`;

const FilterBase = styled.span`
  display: inline-block;
  padding: 7px 8px 7px 7px;
`;

const FilterActionItem = `
  cursor: pointer;
  transition: color ${TransitionConfig};
`;

const FilterSelect = `
  color: ${Colors.violet};
  
  &:hover {
    color: ${Colors.shade03}
  }
`;

const ItemSelect = styled(FilterBase)`
  padding-right: 0;
  z-index: 21;

  span {
    ${FilterActionItem};
    ${FilterSelect};
  }
`;

const Reset = styled(FilterBase)`
  float: right;
  ${FilterActionItem};
  ${FilterSelect};
`;

const Icon = styled(IconBase)`
  vertical-align: -5px;
  transition: none;
  
  &.icon-reload {
    margin-left: -7px;
  }
  &.icon-arrow-down {
    margin-left: -7px;    
  }
`;

export {
  Container, ItemSelect, Reset, Icon,
};
